export default class BoostCommerceProductFilterAndSearch {
  /**
   * @type {string}
   */
  #appName;

  /**
   * @type {AppConfig}
   */
  #config;

  /**
   *
   * @param {string} appName
   * @param {AppConfig} config
   */
  constructor(appName, config) {
    this.#appName = appName;
    this.#config = config;
  }

  /**
   *
   */
  fix() {
    if (typeof(window.BCSfFilterCallback) === 'function') {
      let origCallback = window.BCSfFilterCallback;
      window.BCSfFilterCallback = (data) => {
        if (data.products && Array.isArray(data.products)) {
          data.products.forEach(product => {
            if (!product.handle) {
              return;
            }
            Spurit[this.#appName].snippet.products[product.handle] = product;
          });
          this.#config.snippet().fillFromSource();
        }
        origCallback(data);
      };
    }
  }
}